export default __webpack_public_path__ + "static/media/Remove-Solution.000f423a.svg";